// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bas_a","InstagramEmbed__mask":"bas_b bhk_bi bhk_bo bhk_wx"};